import { createAction } from 'redux-actions';
export const fetchArtAuthor = createAction('ART_BRANDED_POPUP.FETCH_ART_AUTHOR', (payload)=>payload);
export const fetchArtAuthorSuccess = createAction('ART_BRANDED_POPUP.FETCH_ART_AUTHOR_SUCCESS', (payload)=>payload);
